import type { OutcomeDefinition } from "@repo/app-types/entities/outcome";
import {
  getOutcomeAmountFromDefinitionAndGrading,
  getOutcomeResultForValueId,
  getOutcomeValueFromDefinitionAndGrading,
  isRevenueOutcomeDefinition,
  type GradingOutcome,
} from "@repo/app-types/entities/outcome";
import type { Size } from "@repo/ui/helpers/helpers";
import { OutcomeResultPill } from "@repo/ui/Pills/outcomeResultPill";
import type { FC } from "react";

export interface OutcomeValuePillProps {
  size: Size;
  outcome: GradingOutcome | null | undefined;
  outcomeDefinition: OutcomeDefinition;
}

export const OutcomeValuePill: FC<OutcomeValuePillProps> = ({
  size,
  outcome,
  outcomeDefinition,
}) => {
  const valueId = getOutcomeValueFromDefinitionAndGrading(
    outcomeDefinition,
    outcome,
  );
  const result = getOutcomeResultForValueId(outcomeDefinition, valueId);

  if (!result) {
    return <span className="text-gray-400">--</span>;
  }

  const revenueAmount = isRevenueOutcomeDefinition(outcomeDefinition)
    ? getOutcomeAmountFromDefinitionAndGrading(outcomeDefinition, outcome)
    : undefined;

  return (
    <OutcomeResultPill
      size={size}
      result={result}
      revenueAmount={revenueAmount}
    />
  );
};
